import Cookies from 'js-cookie';
import { getHost } from '@/libraries/url';

export const EnumCookiesName = {
    PromotionCode: 'promotionCode',
};

export function setHostCookies(name: string, value: string | object, options: Cookies.CookieAttributes | undefined = {}) {
    const cookieValue = typeof value === 'string' ? value : JSON.stringify(value);
    return Cookies.set(name, cookieValue, { domain: getHost(), ...options });
}

export function removeHostCookies(name: string, options: Cookies.CookieAttributes | undefined = {}) {
    return Cookies.remove(name, { domain: getHost(), ...options });
}
